module.exports = __webpack_public_path__ + "static/img/taxcellent_bg_01.3c9933d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/matrix/taxcellent_bg_01.png
// module id = /vEd
// module chunks = 34